module.exports = __webpack_public_path__ + "img/it_it_day-6.3d497863.svg";